export enum AllergySeverity {
    Minor = 1,
    Moderate = 2,
    Major = 3,
}
